import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProductCard } from '../components/ProductCard';
import { ChevronRightIcon, MinusIcon, PlusIcon, TruckIcon, ShieldCheckIcon, HeartIcon, StarIcon } from 'lucide-react';
// Sample product data with real flower images
const products = [{
  id: '1',
  name: 'Elegant Rose Bouquet',
  price: 3500,
  image: 'https://images.unsplash.com/photo-1548094990-c16ca90f1f0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  description: 'A stunning arrangement of premium roses in your choice of color. Perfect for anniversaries, birthdays, or just to say "I love you". Each bouquet contains 12 roses carefully selected for quality and longevity.',
  images: ['https://images.unsplash.com/photo-1548094990-c16ca90f1f0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1561181286-d3fee3785613?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['Red', 'Pink', 'White', 'Yellow'],
  bouquetSizes: ['Classic (12 stems)', 'Deluxe (24 stems)', 'Grand (36 stems)'],
  rating: 4.8,
  reviewCount: 124,
  isNew: true
}, {
  id: '2',
  name: 'Peaceful Lily Plant',
  price: 2800,
  image: 'https://images.unsplash.com/photo-1567748157439-651aca2ff064?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  description: 'The Peace Lily is an easy-care plant that adds elegance to any space. Known for its air-purifying qualities, it features glossy green leaves and beautiful white flowers. Comes in a decorative pot.',
  images: ['https://images.unsplash.com/photo-1567748157439-651aca2ff064?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1593691509543-c55fb32d8de5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1509423350716-97f9360b4e09?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['White'],
  potStyles: ['Ceramic White', 'Ceramic Black', 'Natural Basket'],
  plantSizes: ['Small (8" pot)', 'Medium (10" pot)', 'Large (12" pot)'],
  rating: 4.7,
  reviewCount: 89
}, {
  id: '3',
  name: 'Sunshine Sunflower Arrangement',
  price: 4200,
  image: 'https://images.unsplash.com/photo-1470509037663-253afd7f0f51?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Arrangements',
  description: "Bring the sunshine indoors with our vibrant sunflower arrangement. Featuring premium sunflowers complemented by seasonal greenery and accent flowers. A perfect gift to brighten someone's day.",
  images: ['https://images.unsplash.com/photo-1470509037663-253afd7f0f51?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1593106410242-b3c438e8e012?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1455659817273-f96807779a8a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  bouquetSizes: ['Petite (5 stems)', 'Standard (10 stems)', 'Abundant (15 stems)'],
  rating: 4.9,
  reviewCount: 156,
  isBestseller: true
}, {
  id: '4',
  name: 'Exotic Orchid Collection',
  price: 6500,
  image: 'https://images.unsplash.com/photo-1589994160839-163cd867cfe8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Exotic',
  description: 'Our exotic orchid collection features rare and beautiful Phalaenopsis orchids. These elegant flowers are long-lasting and require minimal care. Each plant comes in a stylish pot with care instructions.',
  images: ['https://images.unsplash.com/photo-1589994160839-163cd867cfe8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1566408669374-5a6d5dca6b39?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1610631787813-9eeb1a2386cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['Purple', 'White', 'Pink', 'Yellow'],
  plantSizes: ['Single Stem', 'Double Stem', 'Triple Stem'],
  rating: 4.6,
  reviewCount: 78
}, {
  id: '5',
  name: 'Vibrant Tulip Mix',
  price: 3800,
  image: 'https://images.unsplash.com/photo-1520763185298-1b434c919102?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  description: 'A bright and cheerful arrangement of colorful tulips. This seasonal favorite brings the freshness of spring into any space. Available in various color combinations to suit your preference.',
  images: ['https://images.unsplash.com/photo-1520763185298-1b434c919102?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1581146037057-8213233c5a6f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1582794543139-8ac9cb0f7b11?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['Mixed', 'Pink', 'Yellow', 'Purple'],
  bouquetSizes: ['Small (10 stems)', 'Medium (15 stems)', 'Large (20 stems)'],
  rating: 4.7,
  reviewCount: 92
}, {
  id: '6',
  name: 'Succulent Garden',
  price: 4800,
  image: 'https://images.unsplash.com/photo-1446071103084-c257b5f70672?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  description: 'A beautiful arrangement of various succulents in a stylish container. These low-maintenance plants add a touch of modern greenery to any space. Perfect for homes and offices.',
  images: ['https://images.unsplash.com/photo-1446071103084-c257b5f70672?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1509423350716-97f9360b4e09?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1485955900006-10f4d324d411?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  potStyles: ['Ceramic Bowl', 'Wooden Box', 'Terrarium'],
  plantSizes: ['Small (3 plants)', 'Medium (5 plants)', 'Large (7 plants)'],
  rating: 4.9,
  reviewCount: 118,
  isNew: true
}, {
  id: '7',
  name: 'Classic Carnation Bundle',
  price: 2900,
  image: 'https://images.unsplash.com/photo-1487530811176-3780de880c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  description: 'A timeless arrangement of fresh carnations. Known for their longevity and sweet fragrance, carnations are perfect for expressing gratitude, admiration, and love.',
  images: ['https://images.unsplash.com/photo-1487530811176-3780de880c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1562690868-60bbe7293e94?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1508610048659-a06b669e3321?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['Pink', 'White', 'Red', 'Mixed'],
  bouquetSizes: ['Small (10 stems)', 'Medium (15 stems)', 'Large (20 stems)'],
  rating: 4.6,
  reviewCount: 87
}, {
  id: '8',
  name: 'Hanging Pothos Plant',
  price: 3600,
  image: 'https://images.unsplash.com/photo-1592170577795-32065ae195e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  description: 'The popular Pothos plant is known for its trailing vines and heart-shaped leaves. Easy to care for and perfect for hanging baskets or high shelves. This air-purifying plant thrives in most indoor conditions.',
  images: ['https://images.unsplash.com/photo-1592170577795-32065ae195e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1610630979446-1caf2e55a478?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  potStyles: ['Hanging Basket', 'Macrame Hanger', 'Ceramic Pot'],
  plantSizes: ['4" pot', '6" pot', '8" pot'],
  rating: 4.8,
  reviewCount: 112,
  isBestseller: true
}, {
  id: '9',
  name: 'Fragrant Lavender Pot',
  price: 3200,
  image: 'https://images.unsplash.com/photo-1469259943454-aa100abba749?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  description: 'Bring the calming scent of lavender into your home with our potted lavender plant. Known for its relaxing aroma and beautiful purple blooms, this plant adds both beauty and fragrance to any space.',
  images: ['https://images.unsplash.com/photo-1469259943454-aa100abba749?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1535432938427-e11886f5bbdf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1471086569966-db3eebc25a59?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  potStyles: ['Terracotta Pot', 'Ceramic White', 'Rustic Wooden Box'],
  plantSizes: ['Small (single plant)', 'Medium (three plants)', 'Large (five plants)'],
  rating: 4.7,
  reviewCount: 93
}, {
  id: '10',
  name: 'Romantic Mixed Bouquet',
  price: 4500,
  image: 'https://images.unsplash.com/photo-1591710668263-bee1e9db2a26?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  description: "A luxurious arrangement featuring a mix of seasonal flowers in romantic hues. Perfect for anniversaries, Valentine's Day, or anytime you want to express your love and appreciation.",
  images: ['https://images.unsplash.com/photo-1591710668263-bee1e9db2a26?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1556801712-76c8eb07bbc9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1494336934272-f0a3282f6e45?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  colors: ['Pink & White', 'Red & White', 'Pastel Mix'],
  bouquetSizes: ['Standard', 'Deluxe', 'Premium'],
  rating: 4.9,
  reviewCount: 142
}, {
  id: '11',
  name: 'Monstera Deliciosa',
  price: 5200,
  image: 'https://images.unsplash.com/photo-1614594975525-e45190c55d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  description: 'The iconic Monstera Deliciosa with its distinctive split leaves brings a tropical feel to any space. This statement plant is easy to care for and grows impressively with proper care.',
  images: ['https://images.unsplash.com/photo-1614594975525-e45190c55d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1637967886160-fd76f4ee735d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1632923057155-39a33b9af91a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  potStyles: ['Modern White', 'Natural Basket', 'Terracotta'],
  plantSizes: ['Small (10" pot)', 'Medium (12" pot)', 'Large (14" pot)'],
  rating: 4.8,
  reviewCount: 107
}, {
  id: '12',
  name: 'Seasonal Wildflower Mix',
  price: 3900,
  image: 'https://images.unsplash.com/photo-1563241527-3004b7be0ffd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Arrangements',
  description: 'A natural and rustic arrangement featuring seasonal wildflowers. Each bouquet is unique and showcases the beauty of locally grown flowers. Perfect for bringing a touch of the outdoors inside.',
  images: ['https://images.unsplash.com/photo-1563241527-3004b7be0ffd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1468327768560-75b778cbb551?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1444021465936-c6ca81d39b84?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  bouquetSizes: ['Petite', 'Classic', 'Abundant'],
  rating: 4.7,
  reviewCount: 98
}];
// Additional products for related products section
const relatedProducts = [{
  id: '5',
  name: 'Vibrant Tulip Mix',
  price: 3800,
  image: 'https://images.unsplash.com/photo-1520763185298-1b434c919102?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets'
}, {
  id: '6',
  name: 'Succulent Garden',
  price: 4800,
  image: 'https://images.unsplash.com/photo-1446071103084-c257b5f70672?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  isNew: true
}, {
  id: '7',
  name: 'Classic Carnation Bundle',
  price: 2900,
  image: 'https://images.unsplash.com/photo-1487530811176-3780de880c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets'
}, {
  id: '11',
  name: 'Monstera Deliciosa',
  price: 5200,
  image: 'https://images.unsplash.com/photo-1614594975525-e45190c55d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  isBestseller: true
}];
export function ProductDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const product = products.find(p => p.id === id);
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState(product?.colors?.[0] || '');
  const [selectedBouquetSize, setSelectedBouquetSize] = useState(product?.bouquetSizes?.[0] || '');
  const [selectedPlantSize, setSelectedPlantSize] = useState(product?.plantSizes?.[0] || '');
  const [selectedPotStyle, setSelectedPotStyle] = useState(product?.potStyles?.[0] || '');
  if (!product) {
    return <div className="min-h-screen flex flex-col" data-id="element-930">
        <Header data-id="element-931" />
        <main className="flex-grow flex items-center justify-center" data-id="element-932">
          <div className="text-center" data-id="element-933">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-934">
              Product Not Found
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-935">
              The product you're looking for doesn't exist or has been removed.
            </p>
            <Link to="/shop" className="inline-flex items-center px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors" data-id="element-936">
              Return to Shop
            </Link>
          </div>
        </main>
        <Footer data-id="element-937" />
      </div>;
  }
  // Calculate if shipping is free
  const isShippingFree = product.price * quantity >= 6000;
  return <div className="min-h-screen flex flex-col" data-id="element-938">
      <Header data-id="element-939" />
      <main className="flex-grow" data-id="element-940">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-941">
          {/* Breadcrumbs */}
          <nav className="flex mb-6 text-sm" data-id="element-942">
            <Link to="/" className="text-gray-500 hover:text-gray-700" data-id="element-943">
              Home
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400 flex-shrink-0 self-center" data-id="element-944" />
            <Link to="/shop" className="text-gray-500 hover:text-gray-700" data-id="element-945">
              Shop
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400 flex-shrink-0 self-center" data-id="element-946" />
            <Link to={`/shop?category=${product.category}`} className="text-gray-500 hover:text-gray-700" data-id="element-947">
              {product.category}
            </Link>
            <ChevronRightIcon className="h-4 w-4 mx-2 text-gray-400 flex-shrink-0 self-center" data-id="element-948" />
            <span className="text-gray-900 font-medium" data-id="element-949">{product.name}</span>
          </nav>

          <div className="lg:grid lg:grid-cols-2 lg:gap-x-8" data-id="element-950">
            {/* Product images */}
            <div className="lg:max-w-lg lg:self-start" data-id="element-951">
              <div className="overflow-hidden rounded-lg mb-4" data-id="element-952">
                <img src={product.images[selectedImage]} alt={product.name} className="w-full h-96 object-cover object-center" data-id="element-953" />
              </div>
              <div className="flex gap-4 mt-4" data-id="element-954">
                {product.images.map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`relative rounded-md overflow-hidden w-20 h-20 flex-shrink-0 ${selectedImage === index ? 'ring-2 ring-emerald-500' : 'ring-1 ring-gray-200'}`} data-id="element-955">
                    <img src={image} alt={`${product.name} view ${index + 1}`} className="w-full h-full object-cover object-center" data-id="element-956" />
                  </button>)}
              </div>
            </div>

            {/* Product details */}
            <div className="mt-10 lg:mt-0 lg:pl-8" data-id="element-957">
              <div data-id="element-958">
                <h1 className="text-3xl font-bold text-gray-900" data-id="element-959">
                  {product.name}
                </h1>
                <div className="mt-2" data-id="element-960">
                  <p className="text-2xl font-medium text-emerald-600" data-id="element-961">
                    KES {product.price.toLocaleString()}
                  </p>
                </div>

                {/* Reviews */}
                <div className="mt-3" data-id="element-962">
                  <div className="flex items-center" data-id="element-963">
                    <div className="flex items-center" data-id="element-964">
                      {[0, 1, 2, 3, 4].map(rating => <StarIcon key={rating} className={`h-5 w-5 flex-shrink-0 ${product.rating > rating ? 'text-yellow-400' : 'text-gray-300'}`} data-id="element-965" />)}
                    </div>
                    <p className="ml-2 text-sm text-gray-600" data-id="element-966">
                      {product.rating} ({product.reviewCount} reviews)
                    </p>
                  </div>
                </div>

                <div className="mt-6" data-id="element-967">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-968">
                    Description
                  </h3>
                  <div className="mt-2 text-base text-gray-700 space-y-2" data-id="element-969">
                    <p data-id="element-970">{product.description}</p>
                  </div>
                </div>

                <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-971">
                  <form data-id="element-972">
                    {/* Color selector if available */}
                    {product.colors && product.colors.length > 0 && <div className="mb-6" data-id="element-973">
                        <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-974">
                          Color
                        </h3>
                        <div className="flex flex-wrap gap-2" data-id="element-975">
                          {product.colors.map(color => <button key={color} type="button" onClick={() => setSelectedColor(color)} className={`px-3 py-1 rounded-md text-sm ${selectedColor === color ? 'bg-pink-700 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-976">
                              {color}
                            </button>)}
                        </div>
                      </div>}

                    {/* Bouquet size selector if available */}
                    {product.bouquetSizes && product.bouquetSizes.length > 0 && <div className="mb-6" data-id="element-977">
                          <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-978">
                            Bouquet Size
                          </h3>
                          <div className="flex flex-wrap gap-2" data-id="element-979">
                            {product.bouquetSizes.map(size => <button key={size} type="button" onClick={() => setSelectedBouquetSize(size)} className={`px-3 py-1 rounded-md text-sm ${selectedBouquetSize === size ? 'bg-pink-700 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-980">
                                {size}
                              </button>)}
                          </div>
                        </div>}

                    {/* Plant size selector if available */}
                    {product.plantSizes && product.plantSizes.length > 0 && <div className="mb-6" data-id="element-981">
                        <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-982">
                          Plant Size
                        </h3>
                        <div className="flex flex-wrap gap-2" data-id="element-983">
                          {product.plantSizes.map(size => <button key={size} type="button" onClick={() => setSelectedPlantSize(size)} className={`px-3 py-1 rounded-md text-sm ${selectedPlantSize === size ? 'bg-pink-700 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-984">
                              {size}
                            </button>)}
                        </div>
                      </div>}

                    {/* Pot style selector if available */}
                    {product.potStyles && product.potStyles.length > 0 && <div className="mb-6" data-id="element-985">
                        <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-986">
                          Pot Style
                        </h3>
                        <div className="flex flex-wrap gap-2" data-id="element-987">
                          {product.potStyles.map(style => <button key={style} type="button" onClick={() => setSelectedPotStyle(style)} className={`px-3 py-1 rounded-md text-sm ${selectedPotStyle === style ? 'bg-pink-700 text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-988">
                              {style}
                            </button>)}
                        </div>
                      </div>}

                    {/* Quantity selector */}
                    <div className="mb-6" data-id="element-989">
                      <h3 className="text-sm font-medium text-gray-900 mb-2" data-id="element-990">
                        Quantity
                      </h3>
                      <div className="flex items-center" data-id="element-991">
                        <button type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))} className="p-2 border border-gray-300 rounded-l-md bg-gray-50 hover:bg-gray-100" data-id="element-992">
                          <MinusIcon className="h-4 w-4 text-gray-600" data-id="element-993" />
                        </button>
                        <input type="number" min="1" value={quantity} onChange={e => setQuantity(Math.max(1, parseInt(e.target.value) || 1))} className="p-2 w-16 text-center border-t border-b border-gray-300 focus:outline-none focus:ring-0 focus:border-gray-300" data-id="element-994" />
                        <button type="button" onClick={() => setQuantity(quantity + 1)} className="p-2 border border-gray-300 rounded-r-md bg-gray-50 hover:bg-gray-100" data-id="element-995">
                          <PlusIcon className="h-4 w-4 text-gray-600" data-id="element-996" />
                        </button>
                      </div>
                    </div>

                    {/* Add to cart and wishlist buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-8" data-id="element-997">
                      <button type="button" className="flex-1 bg-pink-700 text-white py-3 px-6 rounded-md hover:bg-pink-800 transition-colors flex items-center justify-center" data-id="element-998">
                        Add to Cart
                      </button>
                      <button type="button" className="flex-1 border border-gray-300 text-gray-700 py-3 px-6 rounded-md hover:bg-gray-50 transition-colors flex items-center justify-center" data-id="element-999">
                        <HeartIcon className="h-5 w-5 mr-2" data-id="element-1000" />
                        Add to Wishlist
                      </button>
                    </div>
                  </form>
                </div>

                {/* Delivery and returns info */}
                <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-1001">
                  <div className="space-y-4" data-id="element-1002">
                    <div className="flex items-start" data-id="element-1003">
                      <TruckIcon className="h-5 w-5 text-pink-700 flex-shrink-0 mt-0.5 mr-3" data-id="element-1004" />
                      <div data-id="element-1005">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-1006">
                          {isShippingFree ? 'Free delivery in Nairobi' : 'Delivery in Nairobi'}
                        </h4>
                        <p className="mt-1 text-sm text-gray-500" data-id="element-1007">
                          {isShippingFree ? 'Orders placed before 2pm are delivered same day' : 'Free delivery for orders above KES 6,000. Orders placed before 2pm are delivered same day'}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1008">
                      <ShieldCheckIcon className="h-5 w-5 text-pink-700 flex-shrink-0 mt-0.5 mr-3" data-id="element-1009" />
                      <div data-id="element-1010">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-1011">
                          Freshness guarantee
                        </h4>
                        <p className="mt-1 text-sm text-gray-500" data-id="element-1012">
                          7-day freshness guarantee or we'll replace your
                          flowers
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Related products section */}
          <div className="mt-16 border-t border-gray-200 pt-16" data-id="element-1013">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1014">
              You might also like
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10" data-id="element-1015">
              {relatedProducts.map(product => <ProductCard key={product.id} id={product.id} name={product.name} price={product.price} image={product.image} category={product.category} isNew={product.isNew} isBestseller={product.isBestseller} data-id="element-1016" />)}
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1017" />
    </div>;
}